import type { ReactNode } from 'react';
import { Suspense } from 'react';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { UserNav } from '@sorare/core/src/components/navigation/UserNav';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useSeriesNav } from '@sorare/core/src/hooks/commonGame/useSeriesNav';
import { lazy } from '@sorare/core/src/lib/retry';

const Notifications = lazy(
  async () => import('#src/components/notification/Notifications/index.tsx'),
  'Notifications'
);

const NavigationCart = lazy(
  async () => import('@sorare/marketplace/src/components/cart/NavigationCart'),
  'NavigationCart'
);

const NavigationSorareWheel = lazy(
  async () =>
    import('@sorare/marketplace/src/components/Wheel/NavigationSorareWheel'),
  'NavigationSorareWheel'
);

const Root = styled(Horizontal)`
  position: relative;
  justify-content: flex-end;
  border-bottom: 1px solid var(--c-nd-150);
  padding: var(--intermediate-unit) var(--double-and-a-half-unit);
`;
const NewPageHeader = styled(Horizontal).attrs({ gap: 2 })`
  flex: 1;
  max-width: 100%;
`;
const PageHeaderRightButton = styled(Horizontal).attrs({ gap: 0.5 })`
  margin-left: auto;
`;
const PageHeaderTitle = styled.div`
  width: 100%;
`;

type Props = { extraHeaderButton?: ReactNode };
export const DesktopWebAppHeader = ({ extraHeaderButton }: Props) => {
  const { sport } = useSportContext();
  const seriesNav = useSeriesNav();

  return (
    <Root>
      <NewPageHeader>
        <PageHeaderTitle id="page-header-title" />
        <div id="page-header-title-breadcrumb" />
        <PageHeaderRightButton id="page-header-right-button" />
      </NewPageHeader>
      {extraHeaderButton}
      <NavigationSorareWheel />
      <Suspense fallback={null}>
        <NavigationCart />
        {!seriesNav && <Notifications />}
      </Suspense>
      <UserNav sport={sport} />
    </Root>
  );
};
